import { makeStyles } from "@mui/styles";
import { Splitter, SplitterOnChangeEvent } from "@progress/kendo-react-layout";
import React, { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { clearVisualEditorSelectionState } from "../store/editorSlice";
import { setPanes } from "../store/visualEditor";
import ConfirmDeleteElement from "./ConfirmDeleteElement";
import DebouncedRenderForm from "./DebouncedRenderForm";
import InsertionDrawer from "./EditorDrawer/InsertionDrawer";
import ExpressionEditorDialog from "./ExpressionEditorDialog";
import KeyboardActions from "./KeyboardActions";
import VisualEditorPanel from "./VisualEditorPanel";

const useStyles = makeStyles(() => ({
  panes: {
    "&.k-splitter .k-pane": {
      overflow: "visible",
    },
  },
}));

const VisualFormEditor: React.FC<{}> = React.memo(() => {
  const dispatch = useAppDispatch();
  const classes = useStyles();

  const panes = useAppSelector(
    (state) => state.developer.edit.visualEditor.panes
  );

  useEffect(() => {
    return () => {
      dispatch(clearVisualEditorSelectionState());
    };
  }, [dispatch]);

  const handleChangePanes = useCallback(
    (event: SplitterOnChangeEvent) => {
      dispatch(setPanes(event.newState));
    },
    [dispatch]
  );

  return (
    <>
      <KeyboardActions />
      <Splitter
        style={{ height: "100%" }}
        className={classes.panes}
        panes={panes}
        onChange={handleChangePanes}
      >
        <InsertionDrawer />
        <DebouncedRenderForm />
        <VisualEditorPanel />
      </Splitter>
      <ConfirmDeleteElement />
      <ExpressionEditorDialog />
    </>
  );
});

VisualFormEditor.displayName = "VisualFormEditor";

export default VisualFormEditor;
